/**
 * Z Index for components
 * Refer to https://material-ui.com/customization/default-theme/?expand-path=%24.zIndex for the default material UI values.
 */
export enum ZIndex {
	DropDownButtonMenu = 1301,
}
